import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import {
    AtualizarCategoriasRespostaChatController,
    GetCategoriasRespostaChatController,
} from "../../../../../Controllers/HelpDesk/GestaoRespostas/GestaoRespostasControllers";
import { ICategorias } from "../../../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";

interface GeralProps {
    IdCategoria: number;
    updateList: () => void;
}

export function Geral(props: GeralProps) {
    const { register, handleSubmit, formState } = useForm<ICategorias>();
    const [Categoria, setCategorias] = useState<ICategorias>();

    useEffect(() => {
        update(props.IdCategoria);
    }, [props.IdCategoria]);

    function update(IdCategoria: number) {
        GetCategoriasRespostaChatController(IdCategoria).then((res) => {
            setCategorias(res);
        });
    }

    function handleEditNameForm(formData: ICategorias) {
        if (Categoria) {
            AtualizarCategoriasRespostaChatController({
                ...Categoria,
                DS_CATEGORIA_RESPOSTA_CHAT: formData.DS_CATEGORIA_RESPOSTA_CHAT,
            }).then(() => {
                props.updateList();
            });
        }
    }

    return (
        <div className="d-flex flex-column flex-lg-row flex-lg-row-fluid">
            {Categoria ? (
                <form
                    className="mb-3"
                    id="group-name-edit-form"
                    onSubmit={handleSubmit(handleEditNameForm)}
                >
                    <>
                        <input
                            className={`form-control placeholder-dark-75 ${
                                formState.errors.DS_CATEGORIA_RESPOSTA_CHAT &&
                                "is-invalid"
                            }`}
                            type="text"
                            defaultValue={Categoria?.DS_CATEGORIA_RESPOSTA_CHAT}
                            name="DS_CATEGORIA_RESPOSTA_CHAT"
                            ref={register({
                                required: "Insira o nome da equipe",
                            })}
                        />
                        <div className="invalid-feedback">
                            {formState.errors.DS_CATEGORIA_RESPOSTA_CHAT
                                ? formState.errors.DS_CATEGORIA_RESPOSTA_CHAT
                                      .message
                                : ""}
                        </div>
                    </>

                    <button className="btn btn-outline-primary font-weight-bold">
                        <FontAwesomeIcon icon={faEdit} size="lg" />
                    </button>
                </form>
            ) : (
                <SpinnerComponent />
            )}
        </div>
    );
}
